angular.module('taric.preferenceCodes', [])
    .component('preferenceCodeButton', require('./components/preference-code-button'))
    .component('preferenceCodePicker', require('./components/preference-code-picker'))
    .filter('preferenceCodeTypeahead', require('./filters/preference-code-typeahead-filter'))
    .factory('preferenceCodeModal', require('./modals/preference-code'))
    .factory('preferenceCodeSelectorModal', require('./modals/preference-code-selector'))
    .factory('preferenceCodeDataService', require('./services/preference-code-data'))
    ;

